module.exports = __webpack_public_path__ + "static/media/CTLA_11-356w.cbcf80ae.jpg";